import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { zindexBack, colorGray100 } from '@resultadosdigitais/tangram-design-tokens';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import Fade from '../Fade';
import { hexToRGB } from '../helper';
var MAX_OPACITY = 0.6;
var Root = styled.div.withConfig({
  displayName: "Overlay__Root",
  componentId: "sc-1tng4o8-0"
})(["", " position:fixed;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;background-color:", ";"], ScopedCssBaseline, function (_ref2) {
  var invisible = _ref2.invisible;
  return invisible ? 'transparent' : "rgba(".concat(hexToRGB(colorGray100), ", ").concat(MAX_OPACITY, ")");
});
var Overlay =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var open = _ref.open,
      keepMounted = _ref.keepMounted,
      zIndex = _ref.zIndex,
      childrenProp = _ref.children,
      style = _ref.style,
      invisible = _ref.invisible,
      rest = _objectWithoutPropertiesLoose(_ref, ["open", "keepMounted", "zIndex", "children", "style", "invisible"]);

  var customStyle = _extends({
    zIndex: zindexBack
  }, style);

  var children = childrenProp;

  if (typeof children === 'string') {
    children =
    /*#__PURE__*/
    React.createElement(React.Fragment, null, children);
  }

  if (
  /*#__PURE__*/
  React.isValidElement(children)) {
    customStyle = _extends({
      zIndex: zIndex
    }, style);
    children =
    /*#__PURE__*/
    React.cloneElement(children, _extends({}, children.props, {
      style: _extends({}, children.style, {
        zIndex: customStyle.zIndex + 1
      })
    }));
  }

  return (
    /*#__PURE__*/
    React.createElement(Fade, {
      "in": open,
      hiddenVisibility: true,
      keepMounted: keepMounted
    },
    /*#__PURE__*/
    React.createElement(Root, _extends({}, rest, {
      ref: ref,
      open: open,
      invisible: invisible,
      keepMounted: keepMounted,
      style: customStyle,
      "aria-hidden": "true"
    }), children))
  );
});
Overlay.displayName = 'Overlay';
Overlay.defaultProps = {
  children: null,
  invisible: false,
  keepMounted: false,
  zIndex: 1
};
process.env.NODE_ENV !== "production" ? Overlay.propTypes = {
  /**
   * Sets the children
   */
  children: PropTypes.node,

  /**
   * Sets true to transparentize the overlay
   */
  invisible: PropTypes.bool,

  /**
   * Sets true to keep mounted even is closed
   * *Deprecated*: used to support old transition
   */
  keepMounted: PropTypes.bool,

  /**
   * Sets if is opened or not
   */
  open: PropTypes.bool.isRequired,

  /**
   * Set the z-index
   */
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : void 0;
export default Overlay;